<template>
    <div class="intro">
        <Spiltline title="赛制"></Spiltline>
        <el-card class="box-card">
            <ul class="rule-list">
                <li>本次比赛为组队赛，可两人一队也可单打，奖金只发给队长，由队长分配</li>
                <li>本次比赛采用多次结算制，分多阶段结算</li>
                <li>单次结算：所有人分数加上该次系数*（总队伍数-当前hp对应名次），同时公开目前为止成绩（hp和分数）</li>
                <li>总系数为500</li>
                <li>探路阶段：10.2 12：00 ~ 10.4 12：00  在10.4 12：00结算一次 系数为60</li>
                <li>优化阶段：10.4 12：00 ~ 10.6 12：00  在10.5和10.6 12：00分别结算一次 系数为100</li>
                <li>冲刺阶段：10.6 12：00 ~ 10.6 24：00  从13：00开始每小时结算一次 系数为20</li>
                <li>报名必须在探路阶段结束前完成</li>
            </ul>
        </el-card>
        <Spiltline title="奖励"></Spiltline>
        <el-card class="box-card">
            拆塔水平提升
        </el-card>
        <el-card class="box-card">
            获得荣誉(网站决定发放称号)
        </el-card>
        <el-card class="box-card">
            Another杯造塔大赛评委资格（如果没咕）
        </el-card>
        <el-card class="box-card">
            <div slot="header" class="clearfix">
                <span>奖金</span>
            </div>
            <ul class="award-list">
                <li>
                    <Money title="排名奖" :color="['#f4cd76', '#cfa453']" 
                        :value="[66, 52, 40, 30, 22, 16, 12, 10]"
                    ></Money>
                </li>
                <li>
                    <Money title="先发制人奖" :value="16"></Money>
                    探路阶段hp最高的队伍，多个则取提交最早的
                </li>
                <li>
                    <Money title="一锤定音奖" :value="16"></Money>
                    最终hp最高的队伍，多个则取提交最早的
                </li>
                <li>
                    <Money title="奇技淫巧奖" :value="20"></Money>
                    core.status.route.length最小的过关录像所属队伍，多个则取提交最早的
                </li>
            </ul>
        </el-card>
        <Spiltline title="备注"></Spiltline>
        <div class="ps">
            <ol class="rule-list">
                <li>多号参赛经证实会取消奖项并取消之后Another杯的参赛资格</li>
                <li>鼓励大群交流，抵制私下py，因此奖金没有头部集中</li>
                <li>本次比赛最终解释权归CC所有</li>
            </ol>
        </div>
    </div>
</template>

<script>
import Spiltline from './Spiltline.vue'
import Money from "./Money.vue"

export default {
    components: {
        Spiltline, Money
    }
}
</script>

<style lang="less" scoped>
.intro {
    margin-bottom: 80px;
}
.box-card {
    max-width: 720px;
    margin: 15px auto;
}
.award-list {
    max-width: 640px;
    margin: auto;
    li {
        overflow-x: auto;
        display: flex;
        align-items: center;
        padding: 5px 0;
    }
}
.rule-list {
    max-width: 640px;
    margin: auto;
    li {
        text-align: left;
    }
}
ul {
    list-style-type: none;
}
</style>